export default __webpack_public_path__ + "static/media/brands.f758a220.png";